export const handleLogError = (error) => {
  if (error.response) {
    console.log(error.response.data)
  } else if (error.request) {
    console.log(error.request)
  } else {
    console.log(error.message)
  }
}

export const getStatus = (s) => {
  if(s === 'PLANNED') return 'Запланирована'
  if(s === 'COMPLETED') return 'Завершена'
  if(s === 'CANCELED') return 'Отменена'
  if(s === 'APPROVED') return 'Подтверждена'
  if(s === 'REJECTED') return 'Отклонена'
  if(s === 'WAIT') return 'Ожидание подтверждения'
}

export const getIcon = (s) => {
  if(s === 'PLANNED') return 'clock outline'
  if(s === 'COMPLETED') return 'check circle'
  if(s === 'CANCELED') return 'cancel'
  if(s === 'APPROVED') return 'handshake'
  if(s === 'REJECTED') return 'ban'
  if(s === 'WAIT') return 'hourglass half'
}

export const getColor = (s) => {
  if(s === 'PLANNED') return 'green'
  if(s === 'COMPLETED') return 'blue'
  if(s === 'CANCELED') return 'red'
  if(s === 'APPROVED') return 'green'
  if(s === 'REJECTED') return 'red'
  if(s === 'WAIT') return 'orange'
}

export const getPoint = (s) => {
  if(s === 'grigorov') return 'Григоровщина'
  if(s === 'stone_log') return 'Каменный Лог'
  if(s === 'benekainys') return 'Бенякони'
  if(s === 'brest') return 'Брест'
}

export const tripHours = [
  {key: 0, value: '00', text: '00 часов'}, {key: 1, value: '01', text: '01 час'}, {key: 2, value: '02', text: '02 часа'},
  {key: 3, value: '03', text: '03 часа'}, {key: 4, value: '04', text: '04 часа'}, {key: 5, value: '05', text: '05 часов'},
  {key: 6, value: '06', text: '06 часов'}, {key: 7, value: '07', text: '07 часов'}, {key: 8, value: '08', text: '08 часов'},
  {key: 9, value: '09', text: '09 часов'}, {key: 10, value: '10', text: '10 часов'}, {key: 11, value: '11', text: '11 часов'},
  {key: 12, value: '12', text: '12 часов'}, {key: 13, value: '13', text: '13 часов'}, {key: 14, value: '14', text: '14 часов'},
  {key: 15, value: '15', text: '15 часов'}, {key: 16, value: '16', text: '16 часов'}, {key: 17, value: '17', text: '17 часов'},
  {key: 18, value: '18', text: '18 часов'}, {key: 19, value: '19', text: '19 часов'}, {key: 20, value: '20', text: '20 часов'},
  {key: 21, value: '21', text: '21 час'}, {key: 22, value: '22', text: '22 часа'}, {key: 23, value: '23', text: '23 часа'}
]

export const tripMins = [
  {key: 0, value: '00', text: '00 минут'}, {key: 1, value: '10', text: '10 минут'}, {key: 2, value: '20', text: '20 минут'},
  {key: 3, value: '30', text: '30 минут'}, {key: 4, value: '40', text: '40 минут'}, {key: 5, value: '50', text: '50 минут'}
]

export const vehicleTypes = [
  {key: 'BUS', value: 'BUS', text: 'Автобус'}, {key: 'AUTO', value: 'AUTO', text: 'Автомобиль'}
]

export const getVehicle = (s) => {
  if (s === 'BUS') return 'Автобус'
  if (s === 'AUTO') return 'Автомобиль'
}

export const ppTypes = [
  {key: 'grigorov', value: 'grigorov', text: 'Григоровщина - Патерниеки'}, {key: 'stone_log', value: 'stone_log', text: 'Каменный Лог - Мядининкай'},
  {key: 'benekainys', value: 'benekainys', text: 'Бенякони - Шальчининкай'}, {key: 'brest', value: 'brest', text: 'Брест - Тересполь'},
  {key: 'paternieki', value: 'paternieki', text: 'Патерниеки - Григоровщина'}, {key: 'miadininkai', value: 'miadininkai', text: 'Мядининкай - Каменный Лог'},
  {key: 'shalchininkai', value: 'shalchininkai', text: 'Шальчининкай - Бенякони'}, {key: 'terespol', value: 'terespol', text: 'Тересполь - Брест'}
]

export const getPP = (s) => {
  if(s === 'grigorov') return 'Григоровщина - Патерниеки'
  if(s === 'stone_log') return 'Каменный Лог - Мядининкай'
  if(s === 'benekainys') return 'Бенякони - Шальчининкай'
  if(s === 'brest') return 'Брест - Тересполь'
  if(s === 'paternieki') return 'Патерниеки - Григоровщина'
  if(s === 'miadininkai') return 'Мядининкай - Каменный Лог'
  if(s === 'shalchininkai') return 'Шальчининкай - Бенякони'
  if(s === 'terespol') return 'Тересполь - Брест'
}


